import { Box, Chip, ChipProps, Stack } from '@mui/material';
import { CheckCircleOutline, HelpOutline, Sell } from '@mui/icons-material';
import { IFeaturePricing } from '../data/types';
import { colors } from '../styles';

const styleByKind: Record<IFeaturePricing['kind'], { bg: string; color: string; icon: JSX.Element }> = {
    included: { bg: 'rgba(15, 157, 88, 0.12)', color: '#0b7a45', icon: <CheckCircleOutline /> },
    'free-trial': { bg: 'rgba(15, 157, 88, 0.14)', color: '#0b7a45', icon: <CheckCircleOutline /> },
    paid: { bg: 'rgba(18, 100, 226, 0.12)', color: '#0f4ea8', icon: <Sell /> },
    contact: { bg: 'rgba(73, 97, 120, 0.12)', color: '#43596e', icon: <HelpOutline /> }
};

interface PricingChipProps {
    pricing: IFeaturePricing;
    size?: ChipProps['size'];
}

const PricingChip = ({ pricing, size = 'small' }: PricingChipProps) => {
    const style = styleByKind[pricing.kind];
    return (
        <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap" useFlexGap>
            {pricing.wasPrice && (
                <Box
                    sx={{
                        color: colors.muted,
                        fontWeight: 800,
                        fontSize: size === 'medium' ? 16 : 14,
                        textDecoration: 'line-through',
                        textDecorationThickness: '2px'
                    }}
                >
                    {pricing.wasPrice}
                </Box>
            )}
            <Chip
                size={size}
                icon={style.icon}
                label={pricing.label}
                sx={{
                    bgcolor: style.bg,
                    color: style.color,
                    fontWeight: 800,
                    border: `1px solid ${style.color}22`,
                    '& .MuiChip-icon': { color: style.color }
                }}
            />
        </Stack>
    );
};

export default PricingChip;
